import useActivityFilterStore from '@app.feature/activityFilter/store/storeActivityFilter'

export const useKeywordField = () => {
  const keyword = useActivityFilterStore((state) => state.keyword)
  const updateKeyword = useActivityFilterStore((state) => state.updateKeyword)

  const handleKeywordChange = (newKeyword: string) => {
    updateKeyword(newKeyword)
  }

  const handleKeywordReset = () => {
    updateKeyword('')
  }

  return {
    keyword,
    onKeywordChange: handleKeywordChange,
    onKeywordReset: handleKeywordReset,
  }
}
